const config = {
  falkenTyreRange: [
    {
      id: "1",
      name: "Wildpeak",
      image: "wildpeak/wildpeak-thumb.webp",
      tyre_image: "wildpeak/wildpeak-tyre.webp",
      typeCount: 3,
      tyreType: [
        {
          id: "1",
          name: "WILDPEAK-AT3WA",
          title: "WILDPEAK AT3WA",
          subTitle:
            "THE WILDPEAK A/T GENERATION, AT3WA, IS ENGINEERED FOR ANY ADVENTURE, AT ANY TIME AND IN ANY WEATHER",
          description:
            "DESIGNED IN JAPAN, the AT3WA combines durable off-road ability and rugged terrain driving without compromises on the road. It represents a true ALL TERRAIN performance tyre." +
            " " +
            "The AT3WA’s centre rib follows a zig-zag pattern and the rugged shoulder design ensures excellent self-cleaning properties resulting in improved traction." +
            " " +
            "Long and wide tread blocks in the centre and phase shifted tread blocks along the outer areas enhance tread stability which in turn lead to an even spread of pressure across the footprint and reassuring traction and braking on loose surfaces." +
            " " +
            "The rugged sidewall design with offset shoulder blocks don’t just provide protection against sharp edged rocks, they also provide extra strength and additional grip. Full-depth sipes and grooves maintain consistent performance and appearance throughout the life of the tyre.",
          slider: [
            {
              image:
                "wildpeak/wildpeak-at3wa/tyres/wildpeak-at3wa-fi.webp",
              alt: "WILDPEAK AT3WA",
            },
            {
              image:
                "wildpeak/wildpeak-at3wa/tyres/falken-wildpeak-at-at3wa-30grad.webp",
              alt: "WILDPEAK AT3WA",
            },
          ],
          partner: [
            {
              image:
                "wildpeak/wildpeak-at3wa/partners/japan-quality.webp",
              alt: "partner",
            },
            {
              image:
                "wildpeak/wildpeak-at3wa/partners/4d-nano.webp",
              alt: "partner",
            },
            {
              image:
                "wildpeak/wildpeak-at3wa/partners/falken-technology-icon-all-season.webp",
              alt: "partner",
            },
          ],
          product_portfolo: [
            "43 Sizes",
            "15 – 20 Inches",
            "Series 45 – 85",
            "Speed index: Q / R / S / T / H / V",
          ],
          product_portfolo_image:
            "wildpeak/at3wa-background-portfolio.webp",
          video:
            "https://www.youtube.com/embed/7O--t-PKiTE?controls=0&autoplay=1&mute=1&playsinline=1&loop=1&playlist=7O--t-PKiTE",
          features: [
            "Tread design combined with a silica tread compound for even wear, snow traction and wet performance",
            "Excellent all-terrain performance is the best ever from Falken, thanks to rugged construction and cutting-edge manufacturing",
            "Developed with 4D-Nano Design technology",
            "Low noise emission and high ride comfort on road",
            "Improved self-cleaning effect in all small and large grooves",
            "True all-season usability",
          ],
          advanced_features: [
            {
              title: "OPTIMIZED TREAD PATTERN",
              image:
                "wildpeak/wildpeak-at3wa/features/tat3wa-optimised-tread-pattern-01.webp",
              product_features: [
                "Centre rib with zig-zag design and ribbed shoulder grooves",
              ],
              function: [
                "Creates additional angles and edges and a more irregular pattern structure",
              ],
              benefit: [
                "Improved traction on and off the road",
                "Enhanced grip in mud and harsh weather conditions",
                "Superb self-cleaning properties",
              ],
            },
            {
              title: "RIGID TREAD BLOCKS",
              image:
                "wildpeak/wildpeak-at3wa/features/tat3wa-rigid-tread-blocks-1-01.webp",
              product_features: [
                "Long and wide tread blocks in center area",
                "Profile blocks with stepdown feature",
              ],
              function: [
                "Increase pattern rigidity and stiffness and distributes pressure more evenly in footprint",
              ],
              benefit: [
                "Increased braking performance and traction on loose unstable surfaces",
              ],
            },
            {
              title: "RUGGED SHOULDER AND UPPER SIDEWALL DESIGN",
              image:
                "wildpeak/wildpeak-at3wa/features/tat3wa-rugged-shoulder-and-upper-sidewall-01.webp",
              product_features: [
                "Aggressive upper sidewall features along with offset shoulder blocks",
              ],
              function: [
                "Stepdown shoulder and tooth design in upper sidewall, creating gripping edges",
              ],
              benefit: [
                "Protects the tyre from sharp rocks and provides additional traction in offroad situations",
              ],
            },
          ],
          brochure:
            "static/pdf/falken/falken-brochures/wildpeak_at3wa_brochure.pdf",
        },
        {
          id: "2",
          name: "WILDPEAK-AT-TRAIL-NEW",
          title: "WILDPEAK A/T TRAIL&nbsp;<span class='green'>NEW</span>",
          subTitle: "RUGGED CROSSOVER CAPABILITY ENGINEERED FOR ADVENTURE",
          description:
            "The WILDPEAK A/T TRAIL is built for adventure, delivering rugged off-road capability without compromise on the open road. Engineered to match the dynamic characteristics of modern crossovers, the A/T TRAIL strikes the perfect balance between aggressive off-road traction and dependable all-weather performance. Durable 2-ply polyester construction and rugged upper sidewall features protect the A/T TRAIL from off-road terrain, while an optimized tread design helps to maintain the efficiency and versatility of a modern CUV. The WILDPEAK A/T TRAIL encourages adventure-seeking crossover owners to discover true all-weather capability.",
          slider: [
            {
              image:
                "wildpeak/wildpeak-at-trail/tyres/features-tire.webp",
              alt: "WILDPEAK A/T TRAIL NEW",
            },
            {
              image:
                "wildpeak/wildpeak-at-trail/tyres/wp-at-trail-face.webp",
              alt: "WILDPEAK A/T TRAIL NEW",
            },
            {
              image:
                "wildpeak/wildpeak-at-trail/tyres/wpat-trail-tread.webp",
              alt: "WILDPEAK A/T TRAIL NEW",
            },
            {
              image:
                "wildpeak/wildpeak-at-trail/tyres/wptrail-three-quarter.webp",
              alt: "WILDPEAK A/T TRAIL NEW",
            },
            {
              image:
                "wildpeak/wildpeak-at-trail/tyres/wptrail-tread.webp",
              alt: "WILDPEAK A/T TRAIL NEW",
            },
          ],
          partner: [
            {
              image:
                "wildpeak/wildpeak-at3wa/partners/japan-quality.webp",
              alt: "WILDPEAK-AT-TRAIL-NEW",
            },
          ],
          product_portfolo: [
            "17 Sizes",
            "16 – 20 Inches",
            "Series 50 – 70",
            "Speed index: H / V",
          ],
          product_portfolo_image:
            "wildpeak/at-trail-background-portfolio.webp",
          video:
            "https://www.youtube.com/embed/mYX6kNSj1CU?controls=0&autoplay=1&mute=1&playsinline=1&loop=1&playlist=mYX6kNSj1CU",
          features: [],
          advanced_features: [
            {
              title: "CROSSOVER-SPECIFIC CAPABILITY",
              image:
                "wildpeak/wildpeak-at-trail/features/crossover-specific-capability.webp",
              product_features: [
                "Crossover-specific design matches a CUV’s unibody construction and higher center of gravity to provide enhanced handling year-round.",
              ],
              function: [],
              benefit: [],
            },
            {
              title: "ALL-WEATHER TRACTION",
              image:
                "wildpeak/wildpeak-at-trail/features/all-weather traction.webp",
              product_features: [
                "3D Canyon Sipe Technology and increased tread depth provide more winter traction than a traditional all-season tyre.",
              ],
              function: [],
              benefit: [],
            },
            {
              title: "OFF-ROAD DURABILITY",
              image:
                "wildpeak/wildpeak-at-trail/features/off-road-durability.webp",
              product_features: [
                "Durable 2-ply polyester construction and rugged upper sidewall features protect the tyre from sharp rocks and off-road terrain.",
              ],
              function: [],
              benefit: [],
            },
            {
              title: "ON-ROAD DEPENDABILITY",
              image:
                "wildpeak/wildpeak-at-trail/features/on-road-dependability.webp",
              product_features: [
                "An optimized tread design features Falken’s silica-enriched tread compound to deliver superior wear life over a wide range of operating temperatures.",
              ],
              function: [],
              benefit: [],
            },
          ],
          brochure:
            "static/pdf/falken/falken-brochures/wildpeak_at_trail_brochure.pdf",
        },
        {
          id: "3",
          name: "WILDPEAK-MT-NEW",
          title: "WILDPEAK M/T&nbsp;<span class='green'>NEW</span>",
          subTitle: "MAXIMUM OFF-ROAD TRACTION BUILT FOR THE TOUGHEST TERRAIN",
          description:
            "Trusted by the pros to take on the harshest conditions, the tough WILDPEAK M/T is built to get you there and back whether you’re on the pavement, mud, snow or rocks. The M/T features Falken’s proprietary three-ply DURASPEC™ Sidewall Technology developed to sustain the most punishing off-road conditions. DURASPEC™ also features two high ply turn-ups that provide an additional layer of protection and durability. An aggressive upper sidewall provides additional traction at low air pressures on rugged terrain. The WILDPEAK M/T also features exceptional road manners thanks to an optimized variable three-pitch tread pattern and precision manufacturing technology.",
          slider: [
            {
              image:
                "wildpeak/wildpeak-mud-terrain/tyres/wpmt-profile.webp",
              alt: "WILDPEAK M/T NEW",
            },
            // {
            //   image:
            //     "wildpeak/wildpeak-mud-terrain/tyres/wpmt-three-quarter.webp",
            //   alt: "WILDPEAK M/T NEW",
            // },
            {
              image:
                "wildpeak/wildpeak-mud-terrain/tyres/wpmt-tread.webp",
              alt: "WILDPEAK M/T NEW",
            },
            {
              image:
                "wildpeak/wildpeak-mud-terrain/tyres/wpmt-tread2.webp",
              alt: "WILDPEAK M/T NEW",
            },
          ],
          partner: [
            {
              image:
                "wildpeak/wildpeak-at3wa/partners/japan-quality.webp",
              alt: "WILDPEAK-MT-NEW",
            },
          ],
          product_portfolo: [
            "12 Sizes",
            "15 – 18 Inches",
            "Series 70 – 85",
            "Speed index: Q",
          ],
          product_portfolo_image:
            "wildpeak/mt-background-portfolio.webp",
          video:
            "https://www.youtube.com/embed/TeViYxxdNYw?controls=0&autoplay=1&mute=1&playsinline=1&loop=1&playlist=TeViYxxdNYw",
          features: [],
          advanced_features: [
            {
              title: "ADVANCED OFF-ROAD HANDLING",
              image:
                "wildpeak/wildpeak-mud-terrain/features/tire-feature-mt-rugged-tread-blocks.webp",
              product_features: [
                "Rugged and rigid tread blocks feature step‐down supports on the center blocks to provide tread-pattern rigidity in the contact patch, enhancing stability and handling while preventing stones from becoming trapped in the grooves.",
              ],
              function: [],
              benefit: [],
            },
            {
              title: "RUGGED OFF-ROAD PROTECTION",
              image:
                "wildpeak/wildpeak-mud-terrain/features/tire-feature-mt-aggressive-us.webp",
              product_features: [
                "Aggressive upper sidewall along with offset shoulder blocks protect the tire from sharp rocks and provide additional off-road traction at low tire pressures or in off-camber situations.",
              ],
              function: [],
              benefit: [],
            },
            {
              title: "MUD AND ROCK DEFENSE FEATURES",
              image:
                "wildpeak/wildpeak-mud-terrain/features/tire-feature-mt-mud-and-rock.webp",
              product_features: [
                "Mud and rock defence features shed mud from the tread grooves to prevent loss of traction, ensuring maximum grip while preventing rocks from puncturing the base of the tread.",
              ],
              function: [],
              benefit: [],
            },
            {
              title: "QUIET COMFORTABLE RIDE",
              image:
                "wildpeak/wildpeak-mud-terrain/features/tire-feature-mt-optimized-pattern.webp",
              product_features: [
                "Optimized tread pattern with three variable pitches positions the tread blocks to provide an exceptionally quiet ride.",
              ],
              function: [],
              benefit: [],
            },
            {
              title: "DURASPEC™ THREE PLY SIDEWALL",
              image:
                "wildpeak/wildpeak-mud-terrain/features/tire-feature-mt-dura-0.webp",
              product_features: [
                "Falken’s proprietary technology was developed to endure the most punishing off-road conditions. DURASPEC also features two high ply turn-ups that provide an additional layer of protection.",
              ],
              function: [],
              benefit: [],
            },
            {
              title: "HEAT DIFFUSER TECHNOLOGY",
              image:
                "wildpeak/wildpeak-mud-terrain/features/diffusor.webp",
              product_features: [
                "Heat diffusers in the lower sidewall dissipate heat to protect the internal tire components. Keeping this critical area of the tire cool ensures vehicle stability even when towing or carrying heavy loads.",
              ],
              function: [],
              benefit: [],
            },
          ],
          brochure:
            "static/pdf/falken/falken-brochures/wildpeak_mt _brochure.pdf",
        },
      ],
    },
    {
      id: "2",
      name: "Azenis",
      image: "azenis/azenis-thumb.webp",
      tyre_image: "azenis/fk510-1.webp",
      typeCount: 2,
      tyreType: [
        {
          id: "1",
          name: "Azenis-FK510",
          title: "AZENIS FK510",
          subTitle:
            "ULTRA-HIGH PERFORMANCE, ENGINEERED FOR PERFORMANCE, DESIGNED FOR DRIVERS OF PREMIUM VEHICLES",
          description:
            "Falken’s latest generation ultra-high performance summer tyre, the AZENIS FK510 tyre is designed for drivers of premium vehicles looking for excellent grip and outstanding performance. 4D Nano Design enables Falken engineers to optimize new high-performance compounds at the molecular level, enhancing both wear and wet weather traction. Featuring hybrid undertread materials, the FK510 delivers confidence-inspiring handling and stability. The FK510 covers a wide range of today’s luxury sport vehicles, including staggered applications, and is available in sizes ranging from 17 to 22-inch During high-speed cruising on dry roads, it displays a sharper controllability that is brimming with reliability. On wet roads, it balances improved grip performance with excellent stability. It has also inherited all the superior general features of its predecessor model, such as quietness and durability. Honed to the level of premium tyre recognized by the world’s best cars.",
          video:
            "https://www.youtube.com/embed/ZOwo63Bf3oI?controls=0&autoplay=1&mute=1&playsinline=1&loop=1&playlist=ZOwo63Bf3oI",
          features: [
            "<b>Enhanced High-Speed Cornering:</b> <br/>Wide shoulder blocks enhance high-speed cornering and lateral grip.",
            "<b>Excellent Wet Weather Traction:</b> <br/>Advanced 4D Nano Design allows the compound to adapt to dry and wet driving conditions, while four circumferential grooves effectively disperse water to resist hydroplaning.",
            "<b>Confidence-Inspiring Stability:</b> <br/>Optimized void ratio and variable sipe depth allow for controlled flexibility while maintaining overall block rigidity, improving both directional stability and vehicle stopping distances. ",
            "<b>Precise Handling At High Speeds:</b><br/> Hybrid undertread cap ply provides added rigidity and high speed stability through the use of both aramid and nylon materials.",
          ],
          advanced_features: [
            {
              title: "HIGH PERFORMANCE PROFILE",
              image:
                "azenis/azenis-fk510/features/high-performance-profile.webp",
              product_features: [
                "Wide circumferential grooves in advanced pattern design",
              ],
              function: ["Rapid and highly efficient water displacement"],
              benefit: ["Safety and confidence in wet conditions"],
            },
            {
              title: "ACP “ADAPTIVE CONSTANT PRESSURE” TREAD DESIGN",
              image:
                "azenis/azenis-fk510/features/acp.webp",
              product_features: [
                "Intelligently designed tread pattern that adapts to all situations in order to maximise surface area",
              ],
              function: [
                "Consistent, expanded contact area for increased adhesion",
              ],
              benefit: [
                "High levels of directional stability, enhanced all-round grip, with the added benefit of even wear",
              ],
            },
            {
              title: "“SHARP” HIGH PERFORMANCE PROFILE",
              image:
                "azenis/azenis-fk510/features/shapr-high-performance-profile.webp",
              product_features: ["Blade sipes"],
              function: ["Optimised footprint when cornering"],
              benefit: ["Great cornering and improved wet performance"],
            },
          ],
          slider: [
            {
              image:
                "azenis/azenis-fk510/tyres/fk510-1.webp",
              alt: "AZENIS FK510",
            },
            {
              image:
                "azenis/azenis-fk510/tyres/fk510-2.webp",
              alt: "AZENIS FK510",
            },
            {
              image:
                "azenis/azenis-fk510/tyres/fk510-3.webp",
              alt: "AZENIS FK510",
            },
          ],
          partner: [
            {
              image:
                "azenis/azenis-fk510/partners/made-in-japan.webp",
              alt: "WILDPEAK-AT-TRAIL-NEW",
            },
            {
              image:
                "azenis/azenis-fk510/partners/4d-nano.webp",
              alt: "AZENIS FK510",
            },
            {
              image:
                "azenis/azenis-fk510/partners/falken-technology-icon-acp-summer.webp",
              alt: "AZENIS FK510",
            },
            {
              image:
                "azenis/azenis-fk510/partners/fk510-auto-bild-sportscars-en.webp",
              alt: "AZENIS FK510",
            },
            // {
            //   image:
            //     "azenis/azenis-fk510/partners/made-in-japan.webp",
            //   alt: "AZENIS FK510",
            // },
          ],
          brochure:
            "static/pdf/falken/falken-brochures/azenis_fk510_brochure.pdf",
          product_portfolo: [
            "69 Sizes",
            "17 – 22 Inches",
            "Series 25 – 55",
            "Speed index: V / W / Y or (Y) over 300 km/h",
          ],
          product_portfolo_image:
            "azenis/azenis-image.webp",
        },
        {
          id: "2",
          name: "Azenis-FK520",
          title: "AZENIS FK520&nbsp;<span class='green'>NEW</span>",
          subTitle:
            "FROM RACETRACK TO ROAD – THE LATEST GENERATION ",
          description:
            "Experience unparalleled driving performance with the incorporation of cutting-edge technology, delivering ultra-precise handling and exceptional stability at every speed. This innovation draws inspiration from the world of motorsports, seamlessly integrating design components from AZENIS race tyres to ensure optimal control on the road. Elevating safety standards, the tyres boast significantly shorter braking distances in both wet and dry conditions, providing added security for drivers. Enjoy an enhanced driving experience with improved damping comfort and a notable reduction in noise levels. Additionally, these state-of-the-art tyres contribute to fuel efficiency with up to a 10% reduction in weight and optimized rolling resistance, promoting better overall economic value. The aerodynamic sidewall design, adorned with new Nano-Black lettering, not only ensures peak performance but also adds a modern and sophisticated flair to the overall appearance of the vehicle.",
          video:
            "https://www.youtube.com/embed/sTnOGQPLJZM?controls=0&autoplay=1&mute=1&playsinline=1&loop=1&playlist=sTnOGQPLJZM",
          features: [
            "<b>Precise handling ensuring outstanding stability and control at all speeds.",
            "<b>Enhanced safety – shorter braking distances in wet and dry conditions.",
            "<b>Comfortable, cushioned ride, optimised rolling resistance and lower noise.",
            "<b>Aerodynamic sidewall design with new Nano-Black lettering.",
          ],
          advanced_features: [
            {
              title: "ARAMID LAYER REINFORCEMENT",
              image:
                "azenis/azenis-fk520/features/aramid-layer.webp",
              product_features: [
                "A new reinforced layer consisting of Aramid material",
              ],
              function: ["Ultra-crisp handling"],
              benefit: ["Enhanced cornering dynamics and stability even at high"],
            },
            {
              title: "DIAMOND-CUT EDGES AND SILENCING DIMPLES",
              image:
                "azenis/azenis-fk520/features/diamond-cut-edges.webp",
              product_features: [
                "Diamond-cut edges with silencing dimple adapted in all lateral shoulder grooves",
              ],
              function: [
                "Improved ground contact and minimised noise",
              ],
              benefit: [
                "Outstanding cornering and optimum dry braking",
              ],
            },
            {
              title: "LIGHTWEIGHT CONSTRUCTION",
              image:
                "azenis/azenis-fk520/features/lightweight-construction.webp",
              product_features: ["Lightweight design"],
              function: ["Up to 10% weight reduction due to optimised design and construction"],
              benefit: ["Lightweight tyre to conserve resources, reduce undamped mass and improve rolling resistance"],
            },
          ],
          slider: [
            {
              image:
                "azenis/azenis-fk520/tyres/fk520-1.webp",
              alt: "AZENIS FK520",
            },
            {
              image:
                "azenis/azenis-fk520/tyres/fk520-2.webp",
              alt: "AZENIS FK520",
            },
          ],
          partner: [
            {
              image:
                "azenis/azenis-fk520/partners/fk520_auto-bild.webp",
              alt: "AZENIS FK520",
            },
            {
              image:
                "azenis/azenis-fk520/partners/fk520_ace-test.webp",
              alt: "AZENIS FK520",
            },
            {
              image:
                "azenis/azenis-fk520/partners/fk520_auto-motor-and-sport.webp",
              alt: "AZENIS FK520",
            },
            {
              image:
                "azenis/azenis-fk520/partners/fk520_lightweight.webp",
              alt: "AZENIS FK520",
            },
            {
              image:
                "azenis/azenis-fk520/partners/fk520_nano-black.webp",
              alt: "AZENIS FK520",
            },
            {
              image:
                "azenis/azenis-fk520/partners/fk520_GTU.webp",
              alt: "AZENIS FK520",
            },
            {
              image:
                "azenis/azenis-fk520/partners/fk520_arbo.webp",
              alt: "AZENIS FK520",
            },
            {
              image:
                "azenis/azenis-fk520/partners/fk520_sport-auto.webp",
              alt: "AZENIS FK520",
            },
            {
              image:
                "azenis/azenis-fk520/partners/fk520_auto-zeitung.webp",
              alt: "AZENIS FK520",
            }
          ],
          brochure:
            "static/pdf/falken/falken-brochures/Azenis_FK520_Brochure.pdf",
          product_portfolo: [
            "48 Sizes",
            "17 – 21 Inches",
            "Series 30 – 55",
            "Speed index: W / Y",
          ],
          product_portfolo_image:
            "azenis/azenis-fk520-image.webp",
        },
      ],
    },
    {
      id: "3",
      name: "Ziex",
      image: "ziex/ziex-thumb.webp",
      tyre_image: "ziex/falken-ziex-ze310-ecorun.webp",
      typeCount: 2,
      tyreType: [
        {
          id: "1",
          name: "ZIEX-ZE914-ECORUN",
          title: "ZIEX ZE914 ECORUN",
          subTitle: "HIGH PERFORMANCE FOR BROAD APPLICATIONS",
          description:
            "The ZIEX ZE914 ECORUN is a hybrid vehicle tyre with the cost-saving fuel efficiency of a Low Rolling Resistance Compound, engineered with performance in mind. This tyre features an asymmetric tread pattern with four straight wide circumferential grooves for hydroplane resistance, along with a dual high rigidity rib construction -allowing good wet and dry braking stability. The sport-comfort tyre ZE914 is indeed thoughtfully designed with users in mind. This tyre is targeted towards small and medium vehicles, sizes range from 12-inch to 18-inch. The ZE914 ECORUN is a great tyre for enthusiasts looking to save at the pump.",
          slider: [
            {
              image:
                "ziex/ze914-ecorun/tyres/falken-ziex-ze914-ecorun-30grad.webp",
              alt: "ZIEX ZE914 ECORUN",
            },
            {
              image:
                "ziex/ze914-ecorun/tyres/falken-ziex-ze914-ecorun-sidewall.webp",
              alt: "ZIEX ZE914 ECORUN",
            },
          ],
          partner: [
            // {
            //   image:
            //     "ziex/ze914-ecorun/partners/new.webp",
            //   alt: "partner",
            // },
            {
              image:
                "wildpeak/wildpeak-at3wa/partners/japan-quality.webp",
              alt: "partner",
            },
          ],
          product_portfolo: [
            "19 Sizes",
            "16 – 18 Inches",
            "Series 40 – 65",
            "Speed index:H / V / W",
          ],
          product_portfolo_image:
            "ziex/ze914-background-portfolio.webp",
          video:
            "https://www.youtube.com/embed/DNdRbBg2xNA?controls=0&autoplay=1&mute=1&playsinline=1&loop=1&playlist=DNdRbBg2xNA",
          features: [
            "Outstanding grip",
            "Low drive-by noise",
            "Improved rolling resistance",
            "Tailor-made for sporty drivers",
            "Also available as ZE914A Ecorun to fulfil OE market requirements",
          ],
          advanced_features: [
            {
              title: "ADVANCED TREAD PROFILE",
              image:
                "ziex/ze914-ecorun/features/ziex-ze914-ecorun-asymmetric-5-rib-profile-design.webp",
              product_features: ["Asymmetric 5-rib profile design"],
              function: [
                "Rapid and highly efficient water evacuation",
                "High-speed stability",
              ],
              benefit: [
                "Outstanding aquaplaning resistance",
                "Supreme driver confidence in wet conditions",
              ],
            },
            {
              title: "PATTERN NOISE OPTIMISATION",
              image:
                "ziex/ze914-ecorun/features/ziex-ze914-ecorun-pattern-noise-optimization.webp",
              product_features: ["Integrated phase-shifted profile bars"],
              function: ["Actively supresses high frequency road noise"],
              benefit: ["Quieter, more comfortable ride"],
            },
            {
              title: "BROAD OUTSIDE SHOULDER DESIGN",
              image:
                "ziex/ze914-ecorun/features/ziex-ze914-ecorun-broad-outside-shoulder.webp",
              product_features: [
                "Large block structure linked to a circumferencial bar",
              ],
              function: [
                "High stiffness in shoulder design highlights the handling performance of the tyre",
              ],
              benefit: [
                "Optimised traction and direct steering feedback on dry roads",
              ],
            },
          ],
          brochure:
            "static/pdf/falken/falken-brochures/ziex_ze914ec_brochure.pdf",
        },
        {
          id: "2",
          name: "ZIEX-ZE310-ECORUN-NEW",
          title: "ZIEX ZE310 ECORUN&nbsp;<span class='green'>NEW</span>",
          subTitle: "THE LATEST IN HIGH PERFORMANCE",
          description: "",
          slider: [
            {
              image:
                "ziex/ze310-ecorun-new/tyres/falken-ziex-ze310-ecorun.webp",
              alt: "ZIEX ZE310 ECORUN NEW",
            },
            {
              image:
                "ziex/ze310-ecorun-new/tyres/falken-ziex-ze310-ecorun-seitenwand-front.webp",
              alt: "ZIEX ZE310 ECORUN NEW",
            },
          ],
          partner: [
            {
              image:
                "ziex/ze310-ecorun-new/partners/japan-quality.webp",
              alt: "AZENIS FK510",
            },
            {
              image:
                "ziex/ze310-ecorun-new/partners/advanced-4d-nano.webp",
              alt: "AZENIS FK510",
            },
            {
              image:
                "ziex/ze310-ecorun-new/partners/ace-test.webp",
              alt: "AZENIS FK510",
            },
            {
              image:
                "ziex/ze310-ecorun-new/partners/arbo.webp",
              alt: "AZENIS FK510",
            },
            {
              image:
                "ziex/ze310-ecorun-new/partners/auto.webp",
              alt: "AZENIS FK510",
            },
            {
              image:
                "ziex/ze310-ecorun-new/partners/autobild.webp",
              alt: "AZENIS FK510",
            },
            {
              image:
                "ziex/ze310-ecorun-new/partners/autobild-vorbildlich.webp",
              alt: "AZENIS FK510",
            },
            {
              image:
                "ziex/ze310-ecorun-new/partners/auto-motorsports.webp",
              alt: "AZENIS FK510",
            },
            {
              image:
                "ziex/ze310-ecorun-new/partners/tcs.webp",
              alt: "AZENIS FK510",
            },
            {
              image:
                "ziex/ze310-ecorun-new/partners/ze310-auto-bild-en.webp",
              alt: "AZENIS FK510",
            },
            {
              image:
                "ziex/ze310-ecorun-new/partners/ze310-gtue-de.webp",
              alt: "AZENIS FK510",
            },
          ],
          product_portfolo: [
            "128 Sizes",
            "14 – 19 Inches",
            "Series 35 – 70",
            "Speed index: H / V / W / Y",
          ],
          product_portfolo_image:
            "ziex/ze310-background-portfolio.webp",
          video:
            "https://www.youtube.com/embed/DYkFxfFpsaU?controls=0&autoplay=1&mute=1&playsinline=1&loop=1&playlist=DYkFxfFpsaU",
          features: [
            "Excellent traction and grip on wet and dry roads, with enhanced wear performance",
            "Enhanced resistance against aquaplaning",
            "Shorter braking distances",
            "Improved wear life",
            "Further improved noise reduction",
          ],
          advanced_features: [
            {
              title: "VARIBLE HIGH PERFORMANCE PROFILE",
              image:
                "ziex/ze310-ecorun-new/features/falken-ziex-ze310-ecorun-variable-high-performance-profile.webp",
              product_features: [
                "3-groove design for 195 mm width tyres and smaller",
                "4-groove design for 205 mm width tyres and larger",
              ],
              function: [
                "Enhanced profile stiffness and increased tyre footprint",
              ],
              benefit: [
                "Improved wet performance to avoid aquaplanin",
                "Increased traction steering response",
              ],
            },
            {
              title: "ACP “ADAPTIVE CONSTANT PRESSURE” TREAD DESIGN",
              image:
                "ziex/ze310-ecorun-new/features/falken-ziex-ze310-ecorun-acp.webp",
              product_features: [
                "Intelligently designed tread pattern that adapts to all situations in order to maximise surface area",
              ],
              function: [
                "Consistent expanded contact area for increased adhesion",
              ],
              benefit: [
                "High levels of directional stability, enhanced all-round grip, with the added benefit of even wear",
              ],
            },
            {
              title: "THE LATEST IN RESEARCH AND DEVELOPMENT",
              image:
                "ziex/ze310-ecorun-new/features/falken-ziex-ze310-ecorun-4d-nano-design.webp",
              product_features: [
                "Forward-looking research and simulation program",
              ],
              function: ["Nano-scale compound optimisation"],
              benefit: [
                "Excellent traction and grip on wet and dry roads with improved wear life",
              ],
            },
          ],
          brochure:
            "static/pdf/falken/falken-brochures/ziex_ze310 _ brochure.pdf",
        },
      ],
    },
    {
      id: "4",
      name: "Sincera",
      image: "sincera/sincera-thumb.webp",
      tyre_image: "sincera/sn832i-01.webp",
      typeCount: 1,
      tyreType: [
        {
          id: "4",
          name: "Sincera",
          title: "SINCERA sn832I",
          subTitle:
            "SINCERA SN832I HAS BEEN DESIGNED TO MAXIMIZE ECONOMY, COMFORT AND DURABILITY FOR SMALL CARS.",

          description:
            "The Sincera SN832i is a standard tyre with a European taste that provides the longer life and higher durability desired by the African Market. This tyre features a pattern rigidity and contact pressure optimized to enhance long life capabilities. It has an asymmetric tread pattern, which provides a strong profile and construction to enhance durability. The SN832i is a standard tyre for small and midsize vehicles.",

          video:
            "https://www.youtube.com/embed/5Ljsf4AyJnw?controls=0&autoplay=1&mute=1&playsinline=1&loop=1&playlist=5Ljsf4AyJnw",
          features: [
            "The ideal choice for cost-conscious compact and midsize car drivers",
            "Outstandingly economical",
            "Improved handling in wet conditions",
            "Low rolling resistance",
            // "4D-Nano Design technology",
            "Optimum combination of low rolling resistance and safe, secure handling on wet roads",
          ],
          advanced_features: [
            {
              title: "ASYMMETRIC TREAD PATTERN",
              image:
                "sincera/sincera-sn823i/features/sincera-sn832-ecorun-asymmetric-tread-pattern.webp",
              product_features: [
                "4-rib pattern profile with even stiffness distribution",
              ],
              function: [
                "Enhanced profile stiffness and increased tyre footprint",
                "Improved water evacuation",
              ],
              benefit: [
                "Improved wet performance to resist aquaplaning",
                "Enhance wet and dry handling",
              ],
            },
            {
              title: "RESEARCH AND DEVELOPMENT",
              image:
                "sincera/sincera-sn823i/features/sincera-sn832-ecorun-4d-nano-design.webp",
              product_features: [
                "Forward-looking research and simulation technology",
              ],
              function: ["Compound optimisation on nano-scal"],
              benefit: [
                "Excellent traction and grip on wet and dry roads with improved wear life",
              ],
            },
            {
              title: "ECONOMICAL DRIVE",
              image:
                "sincera/sincera-sn823i/features/sincera-sn832-ecorun-economical-drive.webp",
              product_features: [
                "Falken tyres with the ECORUN label feature improved rolling resistance",
              ],
              function: [
                "Saving on fuel consumption by reducing energy loss through friction",
              ],
              benefit: ["Good for the environment, and good for your budget"],
            },
          ],
          slider: [
            {
              image:
                "sincera/sincera-sn823i/tyres/sn832i-01.webp",
              alt: "SINCERA sn832I",
            },
            {
              image:
                "sincera/sincera-sn823i/tyres/sn832i-02.webp",
              alt: "SINCERA sn832I",
            },
            {
              image:
                "sincera/sincera-sn823i/tyres/sn832i-3.webp",
              alt: "SINCERA sn832I",
            },
            {
              image:
                "sincera/sincera-sn823i/tyres/sn832i-angle.webp",
              alt: "SINCERA sn832I",
            },
            {
              image:
                "sincera/sincera-sn823i/tyres/sn832i-side2.webp",
              alt: "SINCERA sn832I",
            },
          ],
          partner: [
            // {
            //   image:
            //     "sincera/sincera-sn823i/partners/4d-nano.webp",
            //   alt: "partner",
            // },
            {
              image:
                "ziex/ze310-ecorun-new/partners/japan-quality.webp",
              alt: "partner",
            },
            {
              image:
                "sincera/sincera-sn823i/partners/falken-technology-icon-ecorun.webp",
              alt: "partner",
            },
          ],
          brochure:
            "static/pdf/falken/falken-brochures/sincera_sn832i_brochure.pdf",
          product_portfolo: [
            "17 Sizes",
            "12 – 16 Inches",
            "Series 55 – 80",
            "Speed index:T / H / V",
          ],
          product_portfolo_image:
            "sincera/sn832i-background-portfolio.webp",
        },
      ],
    },
  ],
  newsRoomDetails: [
    {
      id: "1",
      title: "FALKEN TYRES, A PROUD SPONSOR OF THE SUPADRIFT",
      bannerImageText:
        "Figure 1 Mikey, from XS Drift, Drifiting in Falken Azenis  FK510",
      subTitle: "SUPADRIFT S3 2021 FINAL EVENT, NOV 2021",
      image:
        "falken-tyres-a-proud-sponsor-of-the-supadrift.webp",
      description:
        "The Falken Azenis FK510 has once again proved why it is the preferred tyre that offers maximum treadwear on the tracks. It was a wet freezing weekend, but that didn’t stop the fun that is gauranteed by the SupaDrift Triple Crown. The drivers battled it out in the rain at The Rock Raceway in Brakpan for the last-leg of the SupaDrift Series event of 2021. There were plenty of suprises in the series, with Zein ultimately moving from 3rd place in the series and taking the victory with a standing of 514 points. Zanil took 2nd place with 412 points.",
    },
    {
      id: "2",
      title:
        "FALKEN IN THE RUNNING AGAIN AT THE INTERNATIONAL MOTOR FILM AWARDS",
      bannerImageText: "",
      subTitle: "",
      image:
        "falken-in-the-running-again-at-the-international-motor-film-awards.webp",
      description:
        'Falken has again been nominated for a film production at the "International Motor Film Awards 2022". Last year, tyre brand Falken secured nomination and was able to secure the prize for the best event film 2021 with its film "Whatever Comes Our Way". The recently-released film for this years 24-hour race at the Nürburgring, "A Declaration of Love" made this years shortlist for the prestigious award. The film focuses on the return of fans to the Nürburgring after the coronavirus pandemic. After two long years without spectators, fans were back in the Eifel at the end of May and in record numbers: 230,000 spectators lined the track celebrating their return at the race. This years line-up of nominees at the "International Motor Film Awards" is promising, with the current James Bond "No Time To Die", "The Batman" and Michael Bays "Ambulance" among the nominees in the main category of "Best Drama Feature". The awards ceremony will take place on September 21st 2022, in London, United Kingdom. "It is a great honour to be nominated again in the Best Event Film category the following year. Thank you to Falken Tyre Europe for giving me and us the freedom to produce such films with which we can compete on an international stage," said a delighted Tobias Kahler, director and CEO of MOTIONCTRL FILMPRODUKTION.',
    },
    {
      id: "3",
      title:
        "FALKEN TYRES RECEIVE HIGH MARKS IN WEAR TESTING PERFORMED BY ADAC",
      bannerImageText: "",
      subTitle: "",
      image:
        "falken-tyres-receive-high-marks-in-wear-testing-performed-by-adac.webp",
      description:
        "FALKEN is pleased to announce that FALKEN “AZENIS FK510” and “ZIEX ZE310 ECORUN” tyres have received the No. 1 and No. 3 ratings (respectively) in tyre wear testing conducted by Europe’s largest automotive federation: ADAC (Allgemeiner Deutscher Automobil-Club e.V. (English: General German Automobile Club)). ADAC’s testing involved measuring the quantity of wear particles* generated when driving a fixed distance and included three typical sizes of both summer and winter tyres from 15 different tyre manufacturers. Out of all of the tyres tested for each typical size, our FALKEN “AZENIS FK510” tyres produced the fewest wear particles for its size and so received the No. 1 rating for wear resistance among tyres of size 225/40R18, while our FALKEN “ZIEX ZE310 ECORUN” tyres received the No. 3 rating among tyres of size 185/65R15. Through the active development of tyres that feature outstanding performance in terms of wear resistance, FALKEN is proud to be making a meaningful contribution to the reduction of the overall environmental impact of automobiles. Both of these highly rated tyres were developed using our proprietary “4D NANO DESIGN” and “ADVANCED 4D NANO DESIGN” new materials development technologies, which utilize cutting-edge simulations to analyze and understand the behavior of polymers within tyre rubber at the molecular level in order to provide top-notch performance when it comes to both safety and the environment. *Test tyres were weighed both before and after driving, and the difference in weight between measurements was presumed to be the quantity of wear particles generated as a result of driving.",
    },
    {
      id: "4",
      title:
        "PLACE ON THE WINNER’S PODIUM FOR THE FALKEN AZENIS FK510 SUV IN THE BIG AUTOBILD ALLRAD SUMMER TYRE TEST OF 202",
      bannerImageText: "",
      subTitle: "",
      image:
        "place-on-the-winner’s-podium-for-the-falken-azenis-fk510-suv-in-the-big-autobild-allrad-summer-tyre-test-of-2022.webp",
      description:
        "“Convincing driving characteristics on wet and dry road surfaces, dynamic handling, precise turning performance, short braking distances”. Such are the strengths that the testers at AUTOBILD ALLRAD attested to the Falken AZENIS FK510 SUV in their 2022 summer tyre test. Ten summer tyres and one all-season tyre in the 235/55 R 18 dimension were put to the test, a size which is ideal for the popular compact class SUVs. The Falken tyre was awarded top marks in the wet braking and wet handling categories as well as on the wet circuit. This is no coincidence, as thanks to a uniquely high-performance tread pattern, the large-volume, specially-arranged circumferential tread grooves ensure a rapid water displacement and highly efficient drainage. In addition to this, the wing sipes on the outer edge optimise the contact area of the tyre around curves, and therefore penetrate wet surfaces even more effectively: functions which also contribute to aquaplaning safety. The ratings in individual off-road tests are also impressive, especially for traction in sand and handling on gravel. In each of these categories, the Falken AZENIS FK510 SUV was awarded the second best ranking. A special ACP tread is responsible for the good performance. This Adaptive-Constant-Pressure tread ensures a uniform degree of contact pressure and therefore a constant shape of the tread contact surface. This means that the contact surface is evenly loaded, which leads to added adhesion and therefore to a high degree of directional stability and an even wear pattern. An even wear resistance not only protects the environment, it also protects your wallet. Overall, the Falken AZENIS FK510 SUV came in at third place in the rankings with a rating of “Good”. The Falken AZENIS FK510 SUV, which is factory-fitted to the Porsche Macan and Mercedes-Benz G-Class, is available in 53 dimensions, from 17 to 22 inches, in the 30 – 65 series. The tyre is approved for speeds from 210 km/h to over 300 km/h.",
    },
  ],
};

export default config;
